module.exports = __webpack_public_path__ + "static/media/2.Full Range of Roll Pipes.f6a6d2e1.jpg";